import React, { FC, useCallback, useContext } from 'react';
import { CreateEditEstimateNavEnum } from 'containers/estimates/constants';
import { CustomSwitch } from 'components';
import { CreateEstimateContext } from '../CreateEstimate';
import { useAppDispatch, useAppSelector } from 'hooks';
import { selectIsSignatureEnabled, updateIsSignatureEnabled } from '../../estimatesSlice';
import { selectCustomizations } from 'containers/settings/invoiceSettingsSlice';
import { FeatureToggleState } from 'containers/settings/constants';

interface SignatureOptionsSectionProps {
  className?: string;
}

const SignatureOptionsSection: FC<SignatureOptionsSectionProps> = () => {
  const { setSelectedEstimateTab } = useContext(CreateEstimateContext);
  const dispatch = useAppDispatch();
  const isSignatureEnabled = useAppSelector(selectIsSignatureEnabled);
  const merchantCustomisations = useAppSelector(selectCustomizations);

  const onSignatureConfigChange = useCallback(() => {
    setSelectedEstimateTab(CreateEditEstimateNavEnum.MORE_OPTIONS);
    dispatch(updateIsSignatureEnabled(!isSignatureEnabled));
  }, [setSelectedEstimateTab, dispatch, isSignatureEnabled]);

  const isDisabled =
    !!merchantCustomisations && merchantCustomisations?.customerSignatureConfig === FeatureToggleState.ALWAYS_ON;

  return (
    <div>
      <div className={'mb-2 text-17px font-semibold text-heading'}>Signature</div>

      <div
        className={`relative flex flex-row items-center justify-between gap-3 rounded border
           border-x-borderGray  p-5 ${isDisabled ? 'pointer-events-none' : ''}`}>
        {isDisabled && <div className="slant-lines absolute left-0 z-50 h-full w-full rounded opacity-40" />}

        <div>
          <div className="mb-1 text-17px font-semibold text-heading">Request a customer signature</div>
          <div className="text-sbase text-heading">
            Request customer signatures on estimates to confirm transactions.
          </div>
        </div>
        <CustomSwitch
          enabled={isSignatureEnabled}
          toggleSwitch={onSignatureConfigChange}
          id="create-estimate-allow-sign-toggle-switch"
        />
      </div>
    </div>
  );
};

export default SignatureOptionsSection;
